import { initializeOTelLogger } from '@ennoventure/otel-frontend';
import { getEnvironmentFromDomain } from './utils/helperFunctions';

const environment = getEnvironmentFromDomain();

let packageJson;
try {
  packageJson = require("../package.json");
} catch (error) {
  console.warn("Could not import package.json, using defaults");
  packageJson = { name: "vyu-scan", version: "0.0.0" };
}

const serviceName = packageJson.name || "vyu-scan"
const serviceVersion = packageJson.version || "1.0.0";
export const webLogger = initializeOTelLogger({
  serviceName,
  serviceVersion,
  environment,
  traceMode: 'single',
});


export default webLogger;